import { render, staticRenderFns } from "./FavoritesList.vue?vue&type=template&id=6bb21086&"
import script from "./FavoritesList.vue?vue&type=script&lang=js&"
export * from "./FavoritesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports